<template>
<div>
    <h1 class="title">{{ texts.profile }}</h1>
    <div class="page-form">

        <b-field
            :label="`${texts.oldPassword} (*)`"
            :message="errors.oldPassword ? texts.errors.oldPassword : undefined"
            :type="errors.oldPassword ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.oldPassword"
                :placeholder="texts.oldPassword"
                type="password"
                password-reveal
            />
        </b-field>

        <b-field
            :label="`${texts.newPassword} (*)`"
            :message="errors.newPassword ? texts.errors.newPassword : undefined"
            :type="errors.newPassword ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.newPassword"
                :placeholder="texts.newPassword"
                type="password"
                password-reveal
            />
        </b-field>

        <b-field
            :label="`${texts.newPasswordCheck} (*)`"
            :message="errors.newPasswordCheck ? texts.errors.newPasswordCheck : undefined"
            :type="errors.newPasswordCheck ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.newPasswordCheck"
                :placeholder="texts.newPasswordCheck"
                type="password"
                password-reveal
            />
        </b-field>

    </div>

    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
        <button class="button is-info actions-btn" @click="changePwd()">
            <b-icon
                pack="fas"
                icon="check">
            </b-icon>
        </button>
    </div>

</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'Profile',
    mixins: [ Utils ],
    data () {
        return {
            config: {},
            texts: {},
            form: {
                oldPassword: null,
                newPassword: null,
                newPasswordCheck: null,
            },
            errors: {
                oldPassword: null,
                newPassword: null,
                newPasswordCheck: null,
            }
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (!HealthCareService.isLogged()) this.$router.push('/');
    },
    methods: {
        validateForm() {
            this.errors.oldPassword = !this.form.oldPassword;
            this.errors.newPassword = !this.form.newPassword;
            this.errors.newPasswordCheck = !this.form.newPasswordCheck;
            let isValid = true;
            for (let field in this.errors) {
                if (this.errors.hasOwnProperty(field)) {
                    if (this.errors[field] === true) isValid = false;
                }
            }
            return isValid;
        },
        back() {
            this.$router.push('/professional/call');
        },
        changePwd() {
            const isValid = this.validateForm();
            if (!isValid) return;
            HealthCareService.changePwd({
                "newPassword": this.form.newPassword || undefined,
                "newPasswordCheck": this.form.newPasswordCheck || undefined,
                "oldPassword": this.form.oldPassword || undefined,
            })
            .then(res => {
                this.$buefy.toast.open({ message: this.texts.passwordUpdated, type: 'is-success', position: 'is-bottom' });
                setTimeout(() => {
                    this.$router.push('/professional/call');
                }, 1000);
            })
            .catch(error => {
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
            })
        },
    },
}
</script>

<style scoped lang="scss">
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
    text-align: left;
}

.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/professional/Profile.vue